<button mat-raised-button class="md-small" color="primary" (click)="generarexcel()">
        <mat-icon fontSet="fontawesome" fontIcon="fa-file-excel-o" ></mat-icon>
</button>
